import React from 'react';
import { TextField } from 'mui-rff';
//
import { maxLength, required } from 'utils/validate';

const notesMaxLength = maxLength(255);
const internalNotesMaxLength = maxLength(5_000);

export const createFormFields = (values, isUpdate, disabled) => {
  return [
    {
      size: 4,
      isCopy: true,
      name: 'name',
      field: (
        <TextField
          id='name'
          name='name'
          label='Name'
          fullWidth
          disabled={disabled}
          fieldProps={{ validate: required }}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          name='note'
          multiline
          label='Notes'
          margin='none'
          disabled={disabled}
          fieldProps={{ validate: notesMaxLength }}
        />
      ),
    },
    {
      size: 12,
      name: 'internalNotes',
      field: (
        <TextField
          name='internalNotes'
          multiline
          label='Private notes'
          margin='none'
          disabled={disabled}
          fieldProps={{ validate: internalNotesMaxLength }}
        />
      ),
    },
  ];
};
